import Vue from 'vue';
import Vuetify from 'vuetify';
import VueI18n from 'vue-i18n';
import Vuelidate from 'vuelidate';
import VueClipboard from 'vue-clipboard2';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueResource from 'vue-resource';
import VueFire from 'vuefire';
import Vddl from 'vddl';
import App from './App';
import router from './router';
import http from './resource/index';
import helper from './shared/helper';
import appTypeDocument from './components/app-type-document';

Vue.use(VueFire);
Vue.use(Vuetify);
Vue.use(VueI18n);
Vue.use(Vuelidate);
Vue.use(VueResource);
Vue.use(VueClipboard);
Vue.use(Vddl);
Vue.component('app-type-document', appTypeDocument);
Vue.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyCjVhVe8HfJJVI57btvbnX0EmFTipO5uI4',
		libraries: 'places',
	},
});
Vue.config.lang = 'es';

const i18n = new VueI18n({
	locale: 'es',
});

Vue.prototype.$locale = {
	change(language) {
		i18n.locale = language;
	},
	current() {
		return i18n.locale;
	},
};

Vue.config.productionTip = false;

/* eslint-disable no-new */

function loadLanguages() {
	fetch('/static/locales.json')
		.then((response) => {
			const data = response.json();
			return data;
		})
		.then((json) => {
			i18n.setLocaleMessage('es', json.es);
			i18n.setLocaleMessage('en', json.en);
			Vue.http.options.root = process.env.HOUSEKEEPING_URL;
			Vue.prototype.$imageS3 = process.env.S3_IMG_URL;
			Vue.http.interceptors.push(http.interceptor);
			Object.defineProperty(Vue.prototype, '$breadcrumbsItems', {
				get: function get() {
					const crumbs = [];
					const matched = this.$route.matched;
					matched.forEach((route) => {
						const breadcrumbItem = Object.assign({}, route);
						const hasBreadcrumb = route.meta && route.meta.breadcrumb;
						if (hasBreadcrumb) {
							if (this.$route.name === route.name) {
								breadcrumbItem.params = this.$route.params;
							}
							crumbs.push(breadcrumbItem);
						}
					});
					return crumbs.map(crumb => ({
						id: crumb.name,
						disabled: false,
						text: crumb.meta.breadcrumb,
						href: crumb.path ? crumb.path : '/dashboard',
						params: crumb.params,
						extension: crumb.path === '/transfers' ? 'png' : 'svg',
					}));
				},
			});
		})
		.then(() => {
			const token = helper.methods.getToken();
			if (token) {
				return fetch(`${process.env.PMS_URL}/employee-code`, {
					headers: {
						authorization: `Bearer ${token}`,
					},
				}).then(res => res.json());
			}
			return false;
		})
		.then((employee) => {
			if (employee) {
				Vue.prototype.$userInfo = employee.data;
				window.localStorage.setItem(process.env.STORAGE_USER_KEY, JSON.stringify(employee.data));
			}

			new Vue({
				el: '#app',
				i18n,
				router,
				template: '<App/>',
				components: { App },
			});
		});
}

loadLanguages();



// WEBPACK FOOTER //
// ./src/main.js